'use strict';
import React from 'react';
import flux from 'utils/flux';
import { Navigation } from 'react-router';
import store from 'store';

var HeaderBarShare = React.createClass({
    displayName: 'HeaderBarShare',

    mixins: [
        Navigation
    ],

    propTypes: {
        basket: React.PropTypes.object.isRequired
    },

    toogleAll(allSelected, e) {
        e.preventDefault();
        flux.getActions('share').toggleAllItems({basketId: this.props.basket.get('id'), checkAll: !allSelected});
    },

    toggleCheckAll(size, shouldCheckAll, e) {
        e.preventDefault();
        flux.getActions('share').toggleDownloadAll({basketId: this.props.basket.get('id'), fileKey: size, shouldCheckAll: shouldCheckAll});
    },

    downloadSelected(e) {
        e.preventDefault();
        var data = {}
        var items = this.props.basket.get('items').toJSON().map( item => {
            if ( item.visible && item._checked && item.files.length ) {
                data[ item.id ] = item.files[0].name;
            }
        });
        flux.getStore('share').download(data);
    },

    handleDownloadSubmit(e) {
        var watermarks = this.props.basket.get('items').filter( item => item.get('visible') && item.get('_checked') && item.get('requires_watermark') );
        if ( watermarks.size ) {
            flux.getActions('modals').openWatermarkModal( watermarks );
        }
    },

    render() {
        if ( !this.props.basket || this.props.basket.size === 0 || this.props.basket.get('items').size === 0) {
            return false;
        }

        var items = this.props.basket.get('items').filter( item => true === item.get('visible') );
        var selected = items.filter( item => true === item.get('_checked') );
        var fileKeys = [];
        var countKeys = {};
        items.toJS().forEach( (item) => {
            item.files.forEach((file) => {
                if(countKeys[file.key] === undefined) countKeys[file.key] = {count: 0, selected: 0, name: file.name};
                countKeys[file.key].count++;
                if(file['_download']) countKeys[file.key].selected++;
                if(fileKeys.indexOf(file.key) === -1) {
                    fileKeys.push(file.key);
                }
            })
        });

        var allSelected = selected.size === items.size;
        var mediaboxToken = store.get('mediabox_token');

        var itemsToDownload = flux.getStore('share').getItemsToDownload(items.toJS());


        const { shareMode } = flux.getStore('app').getState().config.toJS();
        let header = (shareMode === 'openDownload') ?
            <div className="headerbar--basket">
                <div className="headerbar__selection">
                    <span className="selection__title">
                        {flux.t('select_all')}:
                    </span>

                    <div className="selection__actions">
                        <form>
                        {fileKeys.map((key, ix) => {
                            return (
                                <div key={'basket_size_'+ix} className="field__checkbox download__checkbox">
                                    <input id="check__all" checked={(countKeys[key].count === countKeys[key].selected)} type="checkbox" readOnly />
                                    <label onClick={this.toggleCheckAll.bind(null, key, (countKeys[key].count !== countKeys[key].selected))} htmlFor="check__all">{countKeys[key].name}</label>
                                </div>
                            );
                        })}
                        </form>
                        <form ref="download" onSubmit={this.handleDownloadSubmit} action={window.config.baseUrl + '/basket/' + this.props.basket.get('id') + '/download'}>
                          <input type="hidden" name="token" value={mediaboxToken} />
                            {itemsToDownload.map( (item, ix) => {
                                return (<input key={'input_' + ix} type="hidden" name={item.id} value={item.size} />);
                            })}
                            <button type="submit" disabled={itemsToDownload.length === 0} className="btn btn-border selection__download">
                                <i className="gopro-download" />
                                {flux.t('download')}
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        :
            <div className="headerbar--share">
                <div className="headerbar__selection">
                    <div className="selection__all">
                        <form className="all__checkbox">
                            <div className="field__checkbox field__checkbox--small">
                                <input id="check__all" checked={allSelected} type="checkbox" readOnly />
                                <label onClick={this.toogleAll.bind( this, allSelected )} htmlFor="check__all">{flux.t('select_all')}</label>
                            </div>
                        </form>
                        <span className="all__count">
                            {flux.getStore('translations').getFormattedMessage('selected_items', {count: selected.size})}
                        </span>
                        <form className="share__download" method="POST" action={window.config.baseUrl + '/download'} onSubmit={this.handleDownloadSubmit}>
                            <input type="hidden" name="token" value={mediaboxToken} />
                            {selected.map( item => {
                                return (
                                    <input type="hidden" key={item.get('id')} name={item.get('id')} value={(item.get('files').size && item.get('files').first().get('key')) || 'master'} />
                                );
                            })}
                            <button type="submit" disabled={selected.size === 0} className="btn btn-border all__button">
                                <i className="gopro-download" />
                                {flux.t('download')}
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        ;
        return header
    }
})

module.exports = HeaderBarShare;



// WEBPACK FOOTER //
// ./app/components/headerBar/headerShare.jsx